import { Component } from 'react';

import { RefreshTokenT } from 'shared/models/auth';
import accessToken from 'utils/accessToken';
import api from 'utils/api';
import authToken from 'utils/authToken';
import hooks from 'utils/hooks';
import { useAuth } from 'utils/hooks/providers/auth-context';

import './Layout.scss';

import HeaderBar from './components/HeaderBar';
import Menu from './components/Menu';

/* eslint-disable */
const NewHOC = (PassedComponent: any) => {
  return class extends Component {
      render(){
          return (
              <>
                  <PassedComponent {...this.props}/>
              </>
          )
      }
  }
}

type LayoutProps = {
  children: any,
}
function Layout({ children }: LayoutProps) {
  const { setAuthState } = useAuth();

  const renderChildren = (toRender: any) => {
    if (toRender === null) {
      return null;
    }
    if (typeof toRender === 'function') {
      const NewComponent = NewHOC(toRender);
      return <NewComponent />; // Render function
    }
    return toRender; // Render componant
  };

  /* Manage the refresh token process before access token has expired */
  const SECOND = 1000;
  hooks.useInterval(() => {
    api.auth.refreshTokens()
      .then((resp: Response) => {
        if (resp.status < 400) {
          resp.json()
            .then((data: RefreshTokenT) => {
              const tokenExtractedData = authToken.extractData(data.access_token);
              accessToken.set(data.access_token);
              setAuthState({
                ...tokenExtractedData,
              });
            });
        }
      });
  }, authToken.extractData(accessToken.get()).exp - SECOND * 5); // Delay: Access token expiry less 5 seconds

  return (
    <div className="layout">
      <Menu />
      <div className="layout--right">
        <HeaderBar />
        <div className="layout__content">
          { renderChildren(children) }
        </div>
      </div>
    </div>
  );
}

export default Layout;
